/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Ok_ButtonInputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Ateliere_Connect_Ok_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_ok_button = /** @type {((inputs?: Ateliere_Connect_Ok_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Ok_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OK")
	if (locale === "de") return /** @type {LocalizedString} */ ("OK")
	if (locale === "it") return /** @type {LocalizedString} */ ("OK")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ХОРОШО")
	if (locale === "es") return /** @type {LocalizedString} */ ("DE ACUERDO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("好的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("わかりました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("OK")
});